import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ListFilter from "Components/listFilter/ListFilter";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import Search from "Components/paginationFilter/PaginationFilter";
import PaginationShow from "Components/paginationShow/PaginationShow";
import Pager from "Components/pager/Pager";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import cx from "classnames";
import { refresh } from "Icons/index.js";
import Select from "Components/select/Select";
import { t } from "i18next";
import s from "./paginationControls.scss";
import qs from "query-string";
import QboxmailApi from "../../../../../qboxmailApi";
import StatusBadge from "../../../../../components/statusBadge/StatusBadge";
import { Icon, archive } from "Icons/index.js";
import { AuthContext } from "../../../../../App";

const api = new QboxmailApi({ useCookie: true });

const AccountSelect = ({ disabled }) => {
  const location = useLocation();
  const history = useHistory();
  const auth = useContext(AuthContext);

  const [accountsList, setAccountsList] = useState([]);

  useEffect(() => {
    if (auth.isLoggedUserAdmin() && location.query.customer_code) {
      getCustomerAccountsList(location.query.customer_code);
    } else {
      getCustomerAccountsList();
    }
  }, [location, auth]);

  const getCustomerAccountsList = async (customerCode = null) => {
    try {
      const res = await api.getDeliveryAccounts({ customer_code: customerCode });

      setAccountsList(
        [{ label: t("select.value.allAccounts"), value: "all" }].concat(
          res.resources.map((item) => ({ label: item.username, value: item.id }))
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getInitialValue = () => {
    const value = accountsList.find((el) => el.value === location.query.account_id);
    return value || { label: t("select.value.allAccounts"), value: "all" };
  };

  let initialValue = accountsList ? getInitialValue() : null;

  return (
    <div className={s.accountFilter}>
      <Select
        disabled={disabled}
        name="account_id"
        noOptionsMessage={t("delivery.accounts.notFound")}
        options={accountsList}
        initialValue={initialValue}
        onChange={(value) => {
          history.push({
            pathname: location.pathname,
            search: qs.stringify({
              ...location.query,
              account_id: value && value.account_id !== "all" ? value.account_id : null,
            }),
          });
        }}
      />
    </div>
  );
};

const PaginationControls = ({
  refreshList,
  isLoading,
  paginationInfo,
  onlyCustomerSelectActive = false,
  statusLabelPrefix,
  forceShowStatusFilter,
}) => {
  const location = useLocation();
  const history = useHistory();
  const auth = useContext(AuthContext);

  return (
    <div className={s.paginationControls}>
      {auth.isLoggedUserAdmin() && (
        <CustomerSelect
          withoutDomainCounter
          className={s.customerSelect}
          initialValue={location.query.customer_code}
          onChange={(value) => {
            history.push({
              pathname: location.pathname,
              search: qs.stringify({
                ...location.query,
                customer_code: value ? value.value : null,
              }),
            });
          }}
        />
      )}
      <AccountSelect disabled={onlyCustomerSelectActive} />
      <Search
        className={s.searchFilter}
        disabled={onlyCustomerSelectActive}
        url={location.pathname}
        paginationFilter={location.query}
        currentQuery={location.query.query}
      />
      {(forceShowStatusFilter || auth.isLoggedUserAdmin()) && (
        <ListFilter
          className={s.statusFilter}
          disabled={onlyCustomerSelectActive}
          values={["all", "enabled", "disabled"]}
          labelPrefix={statusLabelPrefix}
          listFilterLegends={{
            all: <Icon svg={archive} width="0.75rem" height="0.75rem" />,
            enabled: <StatusBadge status />,
            disabled: <StatusBadge />,
          }}
          onChange={(value) => {
            history.push({ pathname: location.pathname, search: qs.stringify({ ...location.query, status: value }) });
          }}
          placeholder="Status"
          param="status"
          active={location.query.status ? location.query.status : "all"}
        />
      )}

      <div className={s.tools}>
        <ButtonIcon
          className={cx(s.iconRefresh, { ["isRefreshing"]: isLoading })}
          icon={refresh}
          onClick={isLoading ? () => {} : refreshList}
        />
        <PaginationShow className={s.paginationSelection} />
        <Pager paginationInfo={{ ...location.query, ...paginationInfo }} />
      </div>
    </div>
  );
};

export default PaginationControls;
